export default "__VITE_ASSET__CNGw2ye3__"